import { Global } from '@emotion/react';

const Fonts = () => (
  <Global
    styles={`
            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-Medium.woff2') format('woff2');
                font-weight: 500;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil.woff2') format('woff2');
                font-weight: normal;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-ExtraBold.woff2') format('woff2');
                font-weight: 800;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-Black.woff2') format('woff2');
                font-weight: 900;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-UltraLight.woff2') format('woff2');
                font-weight: 200;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-Bold.woff2') format('woff2');
                font-weight: bold;
                font-style: normal;
            }

            @font-face {
                font-family: 'Butler Stencil';
                src: url('/fonts/ButlerStencil-Light.woff2') format('woff2');
                font-weight: 300;
                font-style: normal;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Medium.woff2') format('woff2');
                font-weight: 500;
                font-style: normal;
                font-display: swap;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Black.woff2') format('woff2');
                font-weight: 900;
                font-style: normal;
                font-display: swap;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Bold.woff2') format('woff2');
                font-weight: bold;
                font-style: normal;
                font-display: swap;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Light.woff2') format('woff2');
                font-weight: 300;
                font-style: normal;
                font-display: swap;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Regular.woff2') format('woff2');
                font-weight: normal;
                font-style: normal;
                font-display: swap;
            }

            @font-face {
                font-family: 'Roboto';
                src: url('/fonts/Roboto-Thin.woff2') format('woff2');
                font-weight: 100;
                font-style: normal;
                font-display: swap;
            }
        `}
  />
);

export default Fonts;
